import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from './BaseOptionChart';

var pt = require("apexcharts/dist/locales/pt.json");

const CHART_DATA = [

    {name: 'Instruções',
        data: [
            {
            x: '01/01/2022',
            y: 12,
            goals: [
                {
                name: 'Esperadas',
                value: 14,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '02/01/2022',
            y: 44,
            goals: [
                {
                name: 'Esperadas',
                value: 80,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '03/01/2022',
            y: 54,
            goals: [
                {
                name: 'Esperadas',
                value: 70,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '04/01/2022',
            y: 66,
            goals: [
                {
                name: 'Esperadas',
                value: 66,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '05/01/2022',
            y: 81,
            goals: [
                {
                name: 'Esperadas',
                value: 130,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
            ]
            },
            {
            x: '06/01/2022',
            y: 67,
            goals: [
                {
                name: 'Esperadas',
                value: 90,
                strokeWidth: 25,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#91C2C1'
                }
                ]
            }
        ]
    }
];

export default function TaxaRealizacaoExercicios() {

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
        height: 350,
        type: 'bar',
        locales: [pt],
        defaultLocale: 'pt',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '80%',
            borderRadius: 4
        }
      },
      xaxis: { 
        type: 'datetime',
        /*
        labels: {
            format: 'dd/MM'
          }*/
      },
      dataLabels: {
          enabled:true,
          style: {
            fontSize: '12.5px',
            //fontFamily: 'Helvetica, Arial, sans-serif',
            //fontWeight: 'bold',
        },
        formatter: function(val, opt) {
          const goals =
            opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
              .goals
      
          if (goals && goals.length) {
            return `${Math.round((val/goals[0].value)*100)} %`
          }
          return val
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: ['Instruções realizadas','Total de Instruções'],
        markers: {
          fillColors: ['#358A8B','#91C2C1']
        }
      }
  });

  return (
    <Card>
      <CardHeader title="Taxa de Cumprimento de Instruções" />{/*subheader="(+43%) que no ano passado" />*/}
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={250} />
      </Box>
    </Card>
  );
}
